import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Container } from "@mui/system";
import RegisterForm from "./AllInstallerForms/RegisterForm";
import BussinessLicense from "./AllInstallerForms/BussinessLicense";
import WorkingDays from "./AllInstallerForms/WorkingDays";
import AddersRate from "./AllInstallerForms/AddersRate";
import successCheckBox from "../../Assets/images/successCheckBox.png";
import { Avatar } from "@mui/material";
import styled from "styled-components";
import { NavLink } from "react-router-dom";

const steps = ["Register", "Bussiness License", "Working Days", "Adders Rate"];

const CreateInstaller = () => {
    const [activeStep, setActiveStep] = React.useState(0);
    const [skipped, setSkipped] = React.useState(new Set());

    const isStepOptional = (step) => {
        return step === 100;
    };

    const isStepSkipped = (step) => {
        return skipped.has(step);
    };

    const ActiveStepChange = (index) => {
        console.log(index);
        setActiveStep(index);
    };

    const handleNext = () => {
        let newSkipped = skipped;
        if (isStepSkipped(activeStep)) {
            newSkipped = new Set(newSkipped.values());
            newSkipped.delete(activeStep);
        }

        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setSkipped(newSkipped);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleSkip = () => {
        if (!isStepOptional(activeStep)) {
            // You probably want to guard against something like this,
            // it should never occur unless someone's actively trying to break something.
            throw new Error("You can't skip a step that isn't optional.");
        }

        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setSkipped((prevSkipped) => {
            const newSkipped = new Set(prevSkipped.values());
            newSkipped.add(activeStep);
            return newSkipped;
        });
    };

    const handleReset = () => {
        setActiveStep(0);
    };

    const ThisFormShow = () => {
        if (activeStep === 0) {
            return (
                <>
                    <RegisterForm nextForm={handleNext} />
                </>
            );
        }
        if (activeStep === 1) {
            return (
                <>
                    <BussinessLicense nextForm={handleNext} />
                </>
            );
        }
        if (activeStep === 2) {
            return (
                <>
                    <WorkingDays nextForm={handleNext} />
                </>
            );
        }
        if (activeStep === 3) {
            return (
                <>
                    <AddersRate nextForm={handleNext} />
                </>
            );
        }
    };

    return (
        <Container>
            <Box sx={{ width: "100%" }} mb={4}>
                {/* <Stepper activeStep={activeStep} alternativeLabel> */}
                <Stepper
                    activeStep={activeStep}
                    TransitionProps={{ unmountOnExit: false }}
                >
                    {steps.map((label, index) => {
                        const stepProps = {};
                        const labelProps = {};
                        // if (isStepOptional(index)) {
                        //     labelProps.optional = (
                        //         <Typography variant="caption">
                        //             Optional
                        //         </Typography>
                        //     );
                        // }
                        // labelProps.optional = (
                        //     <Typography variant="caption" color="primary">
                        //         Message
                        //     </Typography>
                        // );
                        if (isStepSkipped(index)) {
                            stepProps.completed = false;
                        }
                        return (
                            <Step key={label} {...stepProps}>
                                <StepLabel
                                    onClick={() => ActiveStepChange(index)}
                                    {...labelProps}
                                >
                                    {label}
                                </StepLabel>
                            </Step>
                        );
                    })}
                </Stepper>
                {activeStep === steps.length ? (
                    <React.Fragment>
                        <Typography sx={{ mt: 2, mb: 1 }}>
                            <ImageStyle
                                alt="Upload Document"
                                src={successCheckBox}
                            />
                            <Typography variant="h5" mt={3} align="center">
                                Data Recording has been completed
                            </Typography>
                            <Typography variant="h5" align="center">
                                {" "}
                                Thank You{" "}
                            </Typography>
                        </Typography>
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "row",
                                pt: 2,
                            }}
                        >
                            <Box sx={{ flex: "1 1 auto" }} />
                            <Button>
                                <NavLink to="/dashboard/installer">
                                    {" "}
                                    Show Installers{" "}
                                </NavLink>
                            </Button>
                            <Button onClick={handleReset}>
                                <NavLink to="">Add More Installers</NavLink>
                            </Button>
                        </Box>
                    </React.Fragment>
                ) : (
                    <>
                        {ThisFormShow()}
                        {/* <Box
                            sx={{
                                display: "flex",
                                flexDirection: "row",
                                pt: 2,
                            }}
                        >
                            <Button
                                color="error"
                                variant="outlined"
                                disabled={activeStep === 0}
                                onClick={handleBack}
                                sx={{ mr: 1 }}
                            >
                                Back
                            </Button>
                            <Box sx={{ flex: "1 1 auto" }} />
                            {isStepOptional(activeStep) && (
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={handleSkip}
                                    sx={{ mr: 1 }}
                                >
                                    Skip
                                </Button>
                            )}

                            <Button variant="contained" onClick={handleNext}>
                                {activeStep === steps.length - 1
                                    ? "Finish"
                                    : "Next"}
                            </Button>
                        </Box> */}
                    </>
                )}
            </Box>
        </Container>
    );
};

const ImageStyle = styled.img`
    width: 40vh;
    height: 40vh;
    margin: auto;
    display: block;
`;

export default CreateInstaller;
